// Copyright (c) 2021 WiseTime. All rights reserved.

import { MutableRefObject, useState } from "react"
import { useClickAway, useUpdateEffect } from "react-use"
import {
  DROPDOWN_PARENT_ACTIVE_CLASSNAME,
  DROPDOWN_PARENT_CLASSNAME,
} from "features/shared/classNames"

export const useDropdownHandling = (dropdown: MutableRefObject<HTMLDivElement | null>, isTimeRow = false) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false)

  useUpdateEffect((): void => {
    // keep controls visible if dropdown is active in time row
    const dropdownParent: HTMLUListElement | null | undefined = dropdown.current?.closest(`.${DROPDOWN_PARENT_CLASSNAME}`)
    if (!isTimeRow || dropdownParent == null) {
      return
    }
    if (isDropdownVisible) {
      dropdownParent.classList.add(DROPDOWN_PARENT_ACTIVE_CLASSNAME)
      return
    }

    dropdownParent.classList.remove(DROPDOWN_PARENT_ACTIVE_CLASSNAME)
  }, [isDropdownVisible, isTimeRow])

  useClickAway(dropdown, (): void => {
    if (isDropdownVisible) {
      setIsDropdownVisible(false)
    }
  })

  return {
    isDropdownVisible,
    setIsDropdownVisible,
  }
}
